import React from 'react';
import { Form } from 'react-bootstrap';
import styles from './BreedDropdown.module.scss';

interface BreedDropdownProps {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    breeds: Array<{ ID: string; NAME: string }>;
    placeholder?: string;
    className?: string;
}

function BreedDropdown({ value, onChange, breeds, placeholder = "Velg rase", className }: BreedDropdownProps) {
    return (
        <div className={`${styles.breedDropdownContainer} ${className || ''}`}>
            <Form.Select
                value={value}
                onChange={onChange}
                className={styles.breedDropdown}
            >
                <option value="">{placeholder}</option>
                {breeds.map((breed) => (
                    <option key={breed.ID} value={breed.ID}>
                        {breed.NAME}
                    </option>
                ))}
            </Form.Select>
            <div className={styles.dropdownIcon}>
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </div>
        </div>
    );
}

export default BreedDropdown;
